/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Cute_Parrot_LockInputs */

const fr_fair_cute_parrot_lock = /** @type {(inputs: Fair_Cute_Parrot_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une section`)
};

/**

* @param {Fair_Cute_Parrot_LockInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fair_cute_parrot_lock = /** @type {((inputs?: Fair_Cute_Parrot_LockInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Cute_Parrot_LockInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fair_cute_parrot_lock(inputs)
});